import * as yup from "yup";

export const emailSchema = yup.string()
	.required("Email address is required")
	.email("Enter valid email address")
	.matches(
		/^(?!.*\.\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
		"Enter valid email address"
	);